/**
 * Helpers for expanding per-drop creative fields into per-item bulk update payloads.
 */

import type { BulkUpdatePreparedDropsPayload } from '@/hooks';

export function bulkUpdateNeedsPerItemCreative(
  itemCount: number,
  payload: BulkUpdatePreparedDropsPayload,
): boolean {
  const pt = payload.smsTextsPerDrop;
  const ps = payload.senderNamesPerDrop;
  return (
    (!!pt?.length && pt.length >= itemCount) ||
    (!!ps?.length && ps.length >= itemCount)
  );
}

export function stripPerDropCreativeFields(
  payload: BulkUpdatePreparedDropsPayload,
): BulkUpdatePreparedDropsPayload {
  const { smsTextsPerDrop: _t, senderNamesPerDrop: _s, ...rest } = payload;
  return rest;
}

export function withPerDropRowApplied(
  base: BulkUpdatePreparedDropsPayload,
  index: number,
  perDropTexts?: string[][],
  perDropSenders?: string[][],
): BulkUpdatePreparedDropsPayload {
  const out: BulkUpdatePreparedDropsPayload = { ...base };
  if (perDropTexts?.[index]?.length) out.smsTexts = perDropTexts[index];
  if (perDropSenders?.[index]?.length) out.senderNames = perDropSenders[index];
  return out;
}
